module.exports = __webpack_public_path__ + "static/media/weight.8c2b836a.png";